import React from "react";

/**
 * Container générique pour afficher une liste d'items avec actions
 * Gère l'affichage vide, le header et le bouton de création
 * 
 * @param {Object} props - Les propriétés du composant
 * @param {string} [props.title] - Titre affiché dans le header
 * @param {Array} props.items - Liste des items à afficher
 * @param {Function} props.renderItem - Fonction pour render chaque item (item) => JSX
 * @param {Function} [props.onCreate] - Callback appelé lors du clic sur créer
 * @param {string} [props.emptyMessage="Aucun élément"] - Message affiché quand la liste est vide
 * @param {string} [props.createLabel="Créer"] - Label du bouton de création
 * @param {string} [props.className=""] - Classes CSS additionnelles
 * @returns {JSX.Element} Le container de liste
 */
export default function ListContainer({ title, items, renderItem, onCreate, emptyMessage = "Aucun élément", createLabel = "Créer", className = "", }) {
  return (
    <div className={`list-container ${className}`}>
      <div className="list-header">
        {title && <h3>{title}</h3>}
        {onCreate && <button className="btn" onClick={onCreate}>{createLabel}</button>}
      </div>

      {!items || items.length === 0 ? (
        <div className="list-empty">
			<p>{emptyMessage}</p>
			{onCreate && <button className="btn" onClick={onCreate}>{createLabel}</button>}
        </div>
      ) : (
        <ul className="list-body"> {items.map((item) => renderItem(item))} </ul>
      )}
    </div>
  );
}